function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useRef } from 'react';
import { useParallax } from 'helpful-motion-hooks';
import { motion, useTransform } from 'framer-motion';
import ReactConfigContext from '../../ReactConfigContext';
export default function PatternFigure(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? '1' : _param_variant, images = param.images;
    var ref = useRef(null);
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    var _useParallax = _sliced_to_array(useParallax(ref, [
        'start end',
        'end start'
    ]), 1), y = _useParallax[0];
    var ty = useTransform(y, function(value) {
        return "".concat(value * -15, "%");
    });
    var invty = useTransform(y, function(value) {
        return "".concat(value * 10 - 10, "%");
    });
    if (variant === '1') {
        var _ref;
        return /*#__PURE__*/ React.createElement("figure", {
            ref: ref,
            className: "isolate grid grid-cols-1 grid-rows-1"
        }, /*#__PURE__*/ React.createElement(motion.svg, {
            width: "583",
            height: "588",
            viewBox: "0 0 583 588",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "col-start-1 row-start-1 w-full h-auto",
            style: {
                y: ty
            }
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M437.006 192C410.53 192 389 170.481 389 144.017C389 117.553 410.53 96 437.006 96C463.481 96 485 117.542 485 144.017C485 170.493 463.47 192 437.006 192Z",
            fill: "#5DB3E6"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M193 0C98.1567 0 21 77.187 21 172.02C21 266.852 98.1567 343.98 193 344V252.998C148.344 252.998 112.013 216.69 112.013 172.039C112.013 127.388 148.344 91.0416 193 91.022V0.0195452V0Z",
            fill: "#004E9C"
        })), (images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ React.createElement("div", {
            className: "relative col-start-1 row-start-1 w-full h-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute top-[17%] left-[12%] w-[73%]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-h-1 aspect-w-1"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread({
            className: "w-full h-full object-cover object-center rounded-full bg-subtle-500",
            sizes: "(min-width: 48em) 800px, 100vw"
        }, images[0]))))), images && ((_ref = images === null || images === void 0 ? void 0 : images.length) !== null && _ref !== void 0 ? _ref : 0) > 1 && /*#__PURE__*/ React.createElement("div", {
            className: "relative col-start-1 row-start-1 w-full h-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute bottom-[3%] right-[1%] w-[33%]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-h-1 aspect-w-1"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread({
            className: "w-full h-full object-cover object-center rounded-full bg-subtle-500",
            sizes: "(min-width: 48em) 800px, 100vw"
        }, images[1]))))), /*#__PURE__*/ React.createElement(motion.svg, {
            className: "col-start-1 row-start-1 w-full h-auto z-10",
            width: "583",
            height: "588",
            viewBox: "0 0 583 588",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                y: invty
            }
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M85.5103 588C38.3507 588 0 549.67 0 502.531C0 455.392 38.3507 417 85.5103 417C132.67 417 171 455.371 171 502.531C171 549.691 132.649 588 85.5103 588Z",
            fill: "#FFA500"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M582.994 382.125C583.066 349.049 556.776 322.073 524.395 322C524.263 322 524.132 322.006 524 322.012V353.757C524.108 353.757 524.215 353.751 524.329 353.751C539.581 353.788 551.951 366.485 551.916 382.064C551.886 397.643 539.461 410.285 524.209 410.255C524.143 410.255 524.072 410.255 524.006 410.255V442C524.054 442 524.096 442 524.143 442C556.525 442.073 582.928 415.214 583 382.131",
            fill: "#FF5055"
        })));
    }
    if (variant === '2') {
        return /*#__PURE__*/ React.createElement("figure", {
            ref: ref,
            className: "isolate grid grid-cols-1 grid-rows-1"
        }, /*#__PURE__*/ React.createElement(motion.svg, {
            role: "presentation",
            className: "col-start-1 row-start-1 w-full h-auto",
            width: "462",
            height: "536",
            viewBox: "0 0 462 536",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                y: ty
            }
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M99.3623 336.893C44.7723 336.893 0.362305 381.544 0.362305 436.404C0.362305 491.264 44.7723 535.881 99.3623 535.893V483.249C73.659 483.249 52.7476 462.246 52.7476 436.415C52.7476 410.585 73.659 389.559 99.3623 389.548V336.904V336.893Z",
            fill: "#FF5055"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M93.3308 210C42.3101 210 0.81958 168.532 0.81958 117.533C0.81958 66.5351 42.3101 25 93.3308 25C144.351 25 185.82 66.5128 185.82 117.533C185.82 168.554 144.329 210 93.3308 210Z",
            fill: "#FFA500"
        })), (images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ React.createElement("div", {
            className: "relative col-start-1 row-start-1 w-full h-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute top-[8%] left-0 w-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-h-1 aspect-w-1"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread({
            className: "w-full h-full object-cover object-center rounded-full "
        }, images[0]))))), /*#__PURE__*/ React.createElement(motion.svg, {
            role: "presentation",
            className: "col-start-1 row-start-1 w-full h-auto z-10",
            width: "462",
            height: "536",
            viewBox: "0 0 462 536",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                y: invty
            }
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M450.369 109.069C450.499 49.0671 402.837 0.132943 344.13 0C343.891 0 343.653 0.0110786 343.415 0.0221572V57.6087C343.61 57.6087 343.805 57.5976 344.011 57.5976C371.663 57.6641 394.09 80.6965 394.025 108.958C393.97 137.219 371.446 160.152 343.794 160.097C343.675 160.097 343.545 160.097 343.425 160.097V217.683C343.512 217.683 343.588 217.683 343.675 217.683C402.382 217.816 450.25 169.093 450.38 109.08",
            fill: "#004E9C"
        })));
    }
    if (variant === '3') {
        return /*#__PURE__*/ React.createElement("figure", {
            ref: ref,
            className: "isolate grid grid-cols-1 grid-rows-1"
        }, (images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ React.createElement("div", {
            className: "relative col-start-1 row-start-1 w-full h-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute top-[2.3%] left-[8%] w-[92%]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-h-1 aspect-w-1"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread({
            className: "w-full h-full object-cover object-center rounded-full "
        }, images[0]))))), (images === null || images === void 0 ? void 0 : images.length) && images.length > 1 && /*#__PURE__*/ React.createElement("div", {
            className: "relative col-start-1 row-start-1 w-full h-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "absolute bottom-0 left-0 w-[52%]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-h-1 aspect-w-1"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread({
            className: "w-full h-full object-cover object-center rounded-full "
        }, images[1]))))), /*#__PURE__*/ React.createElement(motion.svg, {
            role: "presentation",
            className: "col-start-1 row-start-1 w-full h-auto z-10",
            width: "502",
            height: "613",
            viewBox: "0 0 502 613",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                y: ty
            }
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M411.162 374C365.394 374 328.162 411.247 328.162 457.009C328.162 502.772 365.394 539.991 411.162 540V496.086C389.613 496.086 372.081 478.566 372.081 457.019C372.081 435.472 389.613 417.933 411.162 417.923V374.009V374Z",
            fill: "#FF5055"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M125.153 86.1793C125.257 38.7698 87.3822 0.105043 40.7304 0C40.5409 0 40.3514 0.00875361 40.1619 0.0175072V45.5188C40.3169 45.5188 40.472 45.51 40.6356 45.51C62.6092 45.5626 80.4309 63.7613 80.3792 86.0918C80.3362 108.422 62.4369 126.542 40.4634 126.498C40.3686 126.498 40.2652 126.498 40.1705 126.498V172C40.2394 172 40.2997 172 40.3686 172C87.0204 172.105 125.059 133.606 125.162 86.1881",
            fill: "#5DB3E6"
        })));
    }
    return null;
}

//# sourceMappingURL=PatternFigure.js.map